'use client';
import React from 'react';
import { Card } from '@/ui/primatives';
import MarkdownViewer from '@/components/MarkdownViewer';
import ApiKeyWidget from '@/components/ApiKeyWidget';

import { IRepository, IUser } from '@/types';

const EmptyRepoCard: React.FC<{ repository: IRepository; currentUser?: IUser }> = ({ repository, currentUser }) => {
  const isOwner = currentUser && currentUser.id === repository.created_by.id;
  let content = `
## This repository is empty
`;

  if (isOwner) {
    content += `
### Configure your API Key
\`\`\`
oxen config --auth hub.oxen.ai [YOUR API KEY]
\`\`\`
---
### Create a new repository from the command line
\`\`\`
echo "# ${repository.name}" >> README.md
oxen init
oxen add README.md
oxen commit -m "Create README"
oxen config --set-remote origin ${repository.url}
oxen push origin main
\`\`\`
---


### Push an existing repository from the command line
\`\`\`
oxen config --set-remote origin ${repository.url}
oxen push origin main
\`\`\`
`;
  }

  return (
    <>
      {isOwner && <ApiKeyWidget user={currentUser} label="Your API key" wide />}
      <Card stretch>
        <MarkdownViewer>{content}</MarkdownViewer>
      </Card>
    </>
  );
};

export default EmptyRepoCard;
